const React = require('react');
const { useState } = require('react');
const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { default: Classes } = require('./styles.scss');
const CenteredLayout = require('components/CenteredLayout');
const { useTheme } = require('@mui/material/styles');
const { default: Button } = require('@mui/material/Button');
const { default: Checkbox } = require('@mui/material/Checkbox');
const { default: FormControl } = require('@mui/material/FormControl');
const { default: FormControlLabel } = require('@mui/material/FormControlLabel');
const { default: Typography } = require('@mui/material/Typography');
const Fonts = require('styles/fonts.json');
const FocusIndicator = require('components/FocusIndicator');
const FullScreenDialog = require('containers/FullScreenDialog');
const PrivacyPolicyContents = require('components/PrivacyPolicyContents');
const TosContents = require('components/TosContents');
const { useForm } = require('hooks/useForm');
const SSOAgreeToTermsFormConfig = require('./formConfig');
const { useDispatch } = require('react-redux');
const { useAppSelector } = require('utils/redux');
const { context } = require('app-context');

const selectors = context.selectors.all;

const internals = {};

module.exports = function SSOAgreeToTerms(props) {

    const {
        withPreventDefault,
        FormBody,
        CheckboxRow,
        StyledButton,
        StyledCheckbox
    } = internals;

    const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);
    const [tosOpen, setTosOpen] = useState(false);
    const { verificationToken } = useAppSelector(selectors.getSignupContext);

    const theme = useTheme();
    const dispatch = useDispatch();

    const onSubmit = () => {
        dispatch(context.actions.signup.authenticate.completeSSO({
            password: null,
            agreeToTerms: true,
            verificationToken
        }));
    };

    const formConfig = SSOAgreeToTermsFormConfig.buildFormConfig({ onSubmit });

    const {
        methods,
        renderForm
    } = useForm(formConfig);

    const isChecked = !!methods.watch('agreeToTerms');

    return <CenteredLayout
        header='Welcome to Nearpeer'
        mainClass={Classes.main}>

        {renderForm(
            <FormBody>
                <CheckboxRow>
                    <FormControl name='agreeToTerms'>
                        <FormControlLabel
                            label={
                                <Typography
                                    sx={{
                                        textAlign:'center',
                                        color: theme.palette.text.contrastText
                                    }}
                                >
                                    I agree with Nearpeer{'\''}s <a
                                        className={Classes.footerLink}
                                        href=''
                                        onClick={withPreventDefault(() => setTosOpen(true))}
                                        data-focus-outline='padding:3,radius:3'
                                    >
                                        Terms of Service
                                    </a> and <a
                                        className={Classes.footerLink}
                                        href=''
                                        onClick={withPreventDefault(() => setPrivacyPolicyOpen(true))}
                                        data-focus-outline='padding:3,radius:3'
                                    >
                                        Privacy Policy
                                    </a>.
                                </Typography>
                            }
                            control={
                                <StyledCheckbox
                                    checked={isChecked}
                                    onChange={(event) => {

                                        methods.setValue('agreeToTerms', event.target.checked, {
                                            shouldDirty: true,
                                            shouldTouch: true,
                                            shouldValidate: true
                                        });
                                    }}
                                    size='small'
                                    name='agree-to-terms-checkbox'
                                    inputProps={{ 'data-focus-outline': 'radius:40', role: 'checkbox' }}
                                />
                            }
                        />
                    </FormControl>
                </CheckboxRow>
                <StyledButton
                    type='submit'
                    disabled={!isChecked}
                    data-focus-outline='radius:40,padding:4'
                    onClick={() => {

                        FocusIndicator.onBlurHandler();
                    }}
                >
                    Confirm
                </StyledButton>
            </FormBody>
        )}
        <FullScreenDialog
            title='Privacy Policy'
            open={privacyPolicyOpen}
            onRequestClose={() => setPrivacyPolicyOpen(false)}
        >
            <PrivacyPolicyContents />
        </FullScreenDialog>
        <FullScreenDialog
            title='Terms of Service'
            open={tosOpen}
            onRequestClose={() => setTosOpen(false)}
        >
            <TosContents />
        </FullScreenDialog>
    </CenteredLayout>;
};

internals.withPreventDefault = (func) => {

    return (evt) => {

        evt.preventDefault();
        func?.(evt);
    };
};

internals.StyledButton = Styled(Button)`
    margin-top: 20px;
    background-color: ${({ theme }) => theme.palette.primary.contrastText};
    color: ${({ theme }) => theme.palette.primary.main};
    height: 3em;
    width: 100%;
    padding: 0;
    &:hover {
        background-color: ${({ theme }) => theme.palette.primary.contrastText};
        color: ${({ theme }) => theme.palette.primary.main};
    }
    &.Mui-disabled{
        background-color: ${({ theme }) => theme.palette.primary.contrastText};
        color: ${({ theme }) => theme.palette.action.disabled};
    }
    font-family: ${Fonts.headerFont};
    font-weight: bold;
    text-transform: none;
    font-size: 1rem;
    line-height: 3em;
`;

internals.StyledCheckbox = Styled(Checkbox)`
    &&& {
        color: ${({ theme }) => theme.palette.common.white};
        fill: ${({ theme }) => theme.palette.common.white};
    }
`;

internals.FormBody = Styled.div`
    display: flex;
    flex-direction: column;
`;

internals.CheckboxRow = Styled.div`
    padding: 15px;
`;
